export const CONFIGCAT_KEYS = {
  MAINTENANCE: "maintenance",
  ADVERT_MODAL: "advertModal",
  ENABLE_EMAIL_VERIFICATION: "enableEmailVerification",
  ENABLE_PASS_VERIFICATION_TYPE: "enablePassVerificationType",
  ENABLE_PASS_RESET: "enablePassReset",
  HIDE_PASS_RESET: "hidePassReset",
};
